var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-overlay",
    { attrs: { value: _vm.opened } },
    [
      _c("v-app", { class: _vm.getClassname }, [
        _vm.step !== 3
          ? _c(
              "div",
              [
                _c(
                  "div",
                  { staticClass: "share-modal-header" },
                  [
                    _c("v-spacer"),
                    _vm._v(" "),
                    _c("div", { staticClass: "share-modal-title" }, [
                      _vm._v(_vm._s(_vm.getTitleByStep))
                    ]),
                    _vm._v(" "),
                    _c("v-spacer"),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "close-btn-wraper",
                        on: {
                          click: function($event) {
                            _vm.$emit("update-share", _vm.step === 3)
                            _vm.resetFlow()
                            _vm.$emit("toggleSharingModal")
                          }
                        }
                      },
                      [
                        _c("v-icon", {
                          staticClass: "fa-light fa-close",
                          staticStyle: { margin: "auto" },
                          attrs: { size: "16", color: "#E5E6EE" }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("v-divider", { staticStyle: { margin: "32px 0" } })
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.step === 1
          ? _c(
              "div",
              { staticStyle: { display: "flex", "flex-direction": "column" } },
              [
                _vm.documentToShare
                  ? _c("div", { staticClass: "document-to-share" }, [
                      _vm._v(
                        "\n        " +
                          _vm._s(
                            _vm.documentToShare.filename ||
                              _vm.documentToShare.description
                          ) +
                          "\n      "
                      )
                    ])
                  : _c(
                      "div",
                      { staticClass: "radio-group-wrapper" },
                      [
                        _c(
                          "v-radio-group",
                          {
                            attrs: { column: "" },
                            on: { change: _vm.handleLinkCreation },
                            model: {
                              value: _vm.initialValue,
                              callback: function($$v) {
                                _vm.initialValue = $$v
                              },
                              expression: "initialValue"
                            }
                          },
                          _vm._l(_vm.options, function(n) {
                            return _c("v-radio", {
                              key: n,
                              staticClass: "radio-btn",
                              attrs: {
                                label: n.label,
                                value: n.value,
                                color: "#161616"
                              }
                            })
                          }),
                          1
                        )
                      ],
                      1
                    ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "guest-share-main-wrapper" },
                  [
                    _c(
                      "v-form",
                      {
                        ref: "form",
                        staticClass: "guest-share-wrapper",
                        model: {
                          value: _vm.valid,
                          callback: function($$v) {
                            _vm.valid = $$v
                          },
                          expression: "valid"
                        }
                      },
                      [
                        _c("v-text-field", {
                          staticClass: "search-field",
                          staticStyle: { "margin-right": "10px" },
                          attrs: {
                            outlined: "",
                            rules: _vm.emailRules,
                            placeholder: "Enter an email to share with",
                            required: ""
                          },
                          model: {
                            value: _vm.email,
                            callback: function($$v) {
                              _vm.email = $$v
                            },
                            expression: "email"
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "v-btn",
                          {
                            staticStyle: {
                              color: "#ffffff",
                              "margin-left": "10px",
                              "margin-bottom": "30px",
                              height: "54px !important"
                            },
                            attrs: { color: _vm.valid ? "#128279" : "#C9CBD5" },
                            on: { click: _vm.initiateShare }
                          },
                          [_vm._v("\n            Share\n          ")]
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("v-divider", { staticStyle: { margin: "40px 0" } }),
                _vm._v(" "),
                _c("div", { staticClass: "share-text-main" }, [
                  !_vm.showSharingOptions
                    ? _c(
                        "div",
                        {
                          staticClass: "create-share-btn",
                          on: { click: _vm.createShareLink }
                        },
                        [_vm._v("\n          Create Share Link\n        ")]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "copied-text",
                      class: { show: _vm.displayNotification }
                    },
                    [_vm._v("Copied to Clipboard!")]
                  ),
                  _vm._v(" "),
                  _vm.shareLink
                    ? _c("div", [
                        _c(
                          "div",
                          { staticClass: "link-actions-container" },
                          [
                            _c(
                              "v-icon",
                              {
                                staticStyle: { "margin-right": "16px" },
                                attrs: { size: "25" },
                                on: { click: _vm.deleteShareLink }
                              },
                              [_vm._v("\n              mdi-window-close")]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "link-wrapper" }, [
                              _c("div", { staticClass: "link-box-wrapper" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass: "link-box",
                                    on: { click: _vm.copyLink }
                                  },
                                  [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(this.shareLink) +
                                        "\n                "
                                    )
                                  ]
                                )
                              ])
                            ])
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            ref: "copyLinkId",
                            staticClass: "copy-link",
                            on: { click: _vm.copyLink }
                          },
                          [
                            _c("v-spacer"),
                            _vm._v(" "),
                            _c("v-icon", {
                              staticClass: "fa-light fa-link",
                              attrs: { size: "20", color: "#128279" }
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "copy-link-text" }, [
                              _vm._v("Copy link")
                            ]),
                            _vm._v(" "),
                            _c("v-spacer")
                          ],
                          1
                        )
                      ])
                    : _vm._e()
                ])
              ],
              1
            )
          : _c("div", [
              _c("div", { staticClass: "confirm-share-wrapper" }, [
                _vm.step === 3
                  ? _c("div", { staticClass: "done-icon-styling" }, [
                      _c("img", {
                        staticStyle: { "align-self": "center" },
                        attrs: { src: _vm.getIconURL }
                      })
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "share-confirmation-text" }, [
                  _vm._v(
                    "\n          " + _vm._s(_vm.getTextByStep) + "\n          "
                  ),
                  _c(
                    "div",
                    { staticClass: "shareType-Styling", style: _vm.styleColor },
                    [_vm._v(_vm._s(_vm.formatResourceType))]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "with-styling" }, [_vm._v("with")]),
                  _vm._v(" "),
                  _c("div", { staticClass: "share-values" }, [
                    _vm._v(_vm._s(_vm.userEmail))
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticStyle: { display: "flex", margin: "32px 0" } },
                  [
                    _vm.step === 2
                      ? _c(
                          "div",
                          {
                            staticClass: "cancel-btn-style",
                            on: {
                              click: function($event) {
                                return _vm.resetFlow()
                              }
                            }
                          },
                          [_vm._v("Cancel")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.step === 2
                      ? _c(
                          "div",
                          {
                            staticClass: "share-btn-style",
                            on: { click: _vm.createShare }
                          },
                          [_vm._v("Share")]
                        )
                      : _vm._e()
                  ]
                )
              ])
            ]),
        _vm._v(" "),
        _vm.step === 3
          ? _c("div", { class: _vm.getBtnWrapperClassname }, [
              _c(
                "div",
                {
                  staticClass: "done-btn-style",
                  on: {
                    click: function($event) {
                      _vm.resetFlow()
                      _vm.$emit("toggleSharingModal")
                      _vm.$emit("update-share", true)
                    }
                  }
                },
                [_vm._v("\n        Done\n      ")]
              )
            ])
          : _vm._e()
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }